import {ComponentRef, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';

export const APP_REUSE_TABLE_SCROLL_ID = 'appReuseTableScrollId';

@Injectable()
export class AppRouteReuseStrategy implements RouteReuseStrategy {

    private scrollCache: {[key: string]: {handle: DetachedRouteHandle, scrollPosition: number}} = {};

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return route.data.reuseScroll === true;
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        const key = this.routeKey(route);
        const scroll = document.getElementById(APP_REUSE_TABLE_SCROLL_ID)?.scrollTop ?? 0;
        this.scrollCache[key] = {handle, scrollPosition: scroll};
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return !!this.scrollCache[this.routeKey(route)];
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        const entry = this.scrollCache[this.routeKey(route)];
        if (!entry) {
            return null;
        }

        setTimeout(() => {
            document.getElementById(APP_REUSE_TABLE_SCROLL_ID)?.scrollTo(0, entry.scrollPosition);
        });

        return entry.handle;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

    clearCache(): void {
        Object.values(this.scrollCache).forEach(entry => this.componentRef(entry.handle)?.destroy());
        this.scrollCache = {};
    }

    private componentRef(handle: DetachedRouteHandle): ComponentRef<unknown> {
        return (handle as {componentRef?: ComponentRef<unknown>})?.componentRef;
    }

    private routeKey(route: ActivatedRouteSnapshot): string {
        return route.pathFromRoot.map(s => s.url.map(u => u.path).join('/')).join('/');
    }
}
